import React from "react"
import { injectIntl } from "react-intl"
import { isError, useQuery } from "react-query"
import { RouteComponentProps } from "react-router"
import SideBar from "../../common/layout/sidebar.component"
import LoadingSpinner from "../../common/spinner/loading.component"
import PaymentAccountService, { RainforestMerchant } from "../../payment-account/service/paymentAccountService"
import { HttpError } from "../../state/helpers/Error"
import RainforestMerchantOnboardingWrapper from "./RainforestMerchantOnboardingWrapper"

type Params = {
    paymentAccountId: string,
}


const RainforestOnboardingMerchantEdit = (props: RouteComponentProps<Params>) => {

    SideBar.activateMenu("payment-processing")

    const { data: merchant, isLoading: isLoadingMerchant } = useQuery(["getMerchant"], () => {
        return PaymentAccountService.getOnBoardingMerchant(props.match.params.paymentAccountId)
    })

    const isRainforestOnboardingMerchant = (merchant: RainforestMerchant | HttpError | undefined)
        : merchant is RainforestMerchant => {
        return (
            merchant != undefined && !isError(merchant)
        )
    }

    if (isLoadingMerchant) {
        return <LoadingSpinner />
    }

    if (isRainforestOnboardingMerchant(merchant))
        return (
            <RainforestMerchantOnboardingWrapper
                session_key={merchant.sessionKey}
                merchant_id={merchant.merchantId}
                merchant_application_id={merchant.merchantApplicationId} />
        )

    return <></>
}

export default injectIntl(RainforestOnboardingMerchantEdit)



// WEBPACK FOOTER //
// ./src/payment-processing/merchant-onboarding/RainforestMerchantOnboardingEdit.tsx